import i18n, { setCustomTranslations, originalResources } from "i18n";

function applyTranslations(
  customTranslations: Record<string, Record<string, string>>
) {
  Object.entries(customTranslations).forEach(([lng, customMap]) => {
    if (!customMap || !Object.keys(customMap).length) return;

    const re = new RegExp(
      Object.keys(customMap)
        .map((k) => k.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"))
        .join("|"),
      "g"
    );

    // Use original unmodified resources from i18n configuration with type assertion
    const typedResources = originalResources as Record<
      string,
      Record<string, any>
    >;
    if (!typedResources[lng]) return;

    Object.keys(typedResources[lng]).forEach((ns) => {
      const original = typedResources[lng][ns];
      const originalStr = JSON.stringify(original);
      const patchedStr = originalStr.replace(re, (m) => customMap[m]);

      const patched = JSON.parse(patchedStr);

      i18n.addResourceBundle(lng, ns, patched, true, true);
    });
  });
}

// === Patch all resources with custom translations per language ===
export function overrideTranslations(
  customTranslations: Record<string, Record<string, string>>
) {
  if (!customTranslations) return;

  // Store custom translations for reapplication when language changes
  setCustomTranslations(customTranslations);

  // Ensure we wait for i18n to be initialized before applying translations
  if (!i18n.isInitialized) {
    const handleInitialized = () => {
      applyTranslations(customTranslations);
      i18n.off("initialized", handleInitialized);
    };
    i18n.on("initialized", handleInitialized);
    return;
  }

  applyTranslations(customTranslations);
}

export default overrideTranslations;
